import { render, staticRenderFns } from "./TranshipmentTransferStopsTab.vue?vue&type=template&id=fadfd6a2"
import script from "./TranshipmentTransferStopsTab.vue?vue&type=script&lang=js"
export * from "./TranshipmentTransferStopsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports